'use client';

import type { ComponentType } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

import type { IconProps } from '@zoomit/icons';
import { AvatarScratch } from '@zoomit/icons';
import { IconButton } from '@zoomit/primitives';
import { BaseMediaUrl, GlobalLoading, NotifBadge, useProfileInfo } from '@zoomit/web-kit';
import { Avatar, cssVar, theme } from '@zoomit/zoomit-ds';

type Props = {
  Logo: ComponentType<IconProps>;
  onProfileClick?: () => void;
};

const DefaultMenuAvatarMobile = (props: Props) => {
  const { onProfileClick, Logo } = props;

  const { isAuthenticated, user, signinRedirect, activeNavigator } = useAuth();

  const { data: profileData, isSuccess: isProfileDataSuccess } = useProfileInfo({
    userId: user?.profile.sub as string,
    enabled: isAuthenticated && !!user?.profile.sub,
    staleTime: Infinity,
  });

  const navigate = useNavigate();

  return isAuthenticated ? (
    <IconButton
      style={{ position: 'relative' }}
      onClick={() => {
        onProfileClick?.();
        navigate('/profile');
      }}
    >
      {isProfileDataSuccess && profileData?.avatar ? (
        <Avatar src={`${BaseMediaUrl}/${profileData.avatar}`} />
      ) : (
        <AvatarScratch size="xl" fill={cssVar(theme.grey1)} />
      )}
      <NotifBadge />
    </IconButton>
  ) : (
    <>
      {activeNavigator === 'signinRedirect' && <GlobalLoading Logo={Logo} />}
      <IconButton onClick={() => signinRedirect({ url_state: window.location.href })}>
        <AvatarScratch size="xl" />
      </IconButton>
    </>
  );
};

export default DefaultMenuAvatarMobile;
